"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiPaths = void 0;
exports.apiPaths = {
    vendor: {
        retrieveWhiteLabelling: "/api/Vendor/RetrieveWhiteLabelling",
        retrieveConfigVersion: "/api/Vendor/RetrieveConfigVersion",
        retrieveConfigByVersion: "/api/Vendor/RetrieveConfigByVersion",
        retrieveBankDetailsByAuctionId: "/api/Vendor/retrieveBankDetailsByAuctionId/:auctionId",
        retrieveServerDateTimeDifference: "/api/Vendor/retrieveServerDateTimeDifference/:localDateTimeTicks",
    },
    auction: {
        retrieveLookup: "/api/Auction/RetrieveAll/Lookup",
        retrieveAuctionPageData: "/api/Auction/RetrieveAuctionPageData",
        retrieveAuctionById: "/api/Auction/Retrieve",
        getAuctionById: "/api/Auction/Retrieve",
        getAuctions: "/api/Auction/RetrieveAll",
        Add: "/api/Auction/Create",
        Update: "/api/Auction/Update",
        Delete: "/api/Auction/Delete",
        createImage: "/api/Auction/CreateAuctionImage",
        retrieveAuctionImage: "/api/Auction/RetrieveAuctionImage",
        retrieveAllAuctionImagesByAuctionId: "/api/Auction/RetrieveAllAuctionImagesByAuctionId/:auctionId",
        createAuctionImage: "/api/Auction/CreateAuctionImage",
        deleteAuctionImage: "/api/Auction/DeleteAuctionImage",
        retrieveAuctionHistoryReport: "api/reports/auctionHistory/:auctionId/:exportType",
        retrieveLotBidHistoryReport: "api/reports/bidHistory/:auctionId/:lotId/:exportType",
        retrieveAuctionCatalogReport: "api/reports/auctionCatalog/:auctionId/:exportType",
        retrieveHomePageData: "/api/Auction/RetrieveHomePageData",
    },
    lots: {
        retrieveLotPageData: "/api/Lot/RetrieveLotPageData",
        retrieveLotDetailsPageData: "/api/Lot/RetrieveLotDetailsPageData",
        sendEnquiry: "/api/Lot/SendEnquiry",
        RetrieveFilteredLotPageData: "/api/Lot/RetrieveFilteredLotPageData",
        RetrieveAllLotTypesLookups: "/api/Lot/RetrieveAllLotTypeLookups/:auctionId",
        MarkNonSTCLotsWithReserveMetAsSold: "/api/Lot/MarkNonSTCLotsWithReserveMetAsSold",
        RetrieveFactsAndFigures: "/api/Lot/RetrieveFactsAndFigures/:auctionId",
    },
    lotWishlist: {
        retrieveLotWishlist: "/api/LotWishlist/RetrieveLotWishlist",
        retrieveAllLotWishlist: "/api/LotWishlist/RetrieveAllLotWishlist",
        retrieveAllMyBiddingActivity: "/api/LotWishlist/RetrieveAllMyBiddingActivity",
        upsertLotWishlist: "/api/LotWishlist/UpsertLotWishlist",
        lotWishlistItemStatusCheck: "/api/LotWishlist/LotWishlistItemStatusCheck/:profileId/:lotId",
        createLotWishlist: "/api/LotWishlist/CreateLotWishlist",
        deleteLotWishlist: "/api/LotWishlist/DeleteLotWishlist",
        RetrieveFilteredLotWishlistData: "/api/LotWishlist/RetrieveFilteredLotWishlistData",
    },
    account: {
        login: "/api/login",
        sendResetPasswordLink: "/api/sendResetPasswordLink",
        register: "/api/register",
        upsertTermsAcceptance: "/api/upsertTermsAcceptance",
        removeAccountDeletion: "/api/removeAccountDeletion",
        retrieveAccount: "/api/User/Retrieve",
        deleteAccount: "/api/deleteAccount",
        upsertUserDevice: "/api/upsertUserDevice",
    },
    contact: {
        retrieveContact: "/api/Contact/RetrieveContact/:contactId",
        retrieveContactsListWithPagination: "/api/Contact/retrieveContactsListWithPagination",
        list: "/api/Contact/List",
    },
    bids: {
        retrieveBiddingPageData: "/api/Bid/RetrieveBiddingPageData",
        create: "/api/Bid/Create",
        createMaximumBid: "/api/Bid/CreateMaximumBid",
        subscribeToBidUpdates: "/api/Bid/SubscribeToBidUpdates",
        unsubscribeToBidUpdates: "/api/Bid/UnsubscribeToBidUpdates",
        getFirebaseConfig: "/api/Bid/GetFirebaseConfig",
        updateOrDeleteBid: "/api/Bid/UpdateOrDeleteBid",
        retrieveDeletedBidAuditHistory: "/api/Bid/RetrieveDeletedBidAuditHistory/:lotId",
        retrieveMaxBid: "/api/Bid/RetrieveMaxBid/:auctionId/:lotId/:profileId",
    },
    profile: {
        retrieveIndividualBiddingProfile: "/api/Profiles/RetrieveIndividualBiddingProfile",
        retrieveBiddingProfiles: "/api/Profile/RetrieveAllBiddingProfilesByIdentityUserId",
        retrieveCompanyBiddingProfile: "/api/Profiles/RetrieveCompanyBiddingProfile",
        validate: "/api/Profiles/ValidateRegisteredProfile",
        individualBiddingProfileCreate: "/api/Profiles/IndividualBiddingProfileCreate",
        individualBiddingProfileUpdate: "/api/Profiles/IndividualBiddingProfileUpdate",
        companyBiddingProfileCreate: "/api/Profiles/CompanyBiddingProfileCreate",
        companyBiddingProfileUpdate: "/api/Profiles/CompanyBiddingProfileUpdate",
        IndividualBiddingProfileDelete: "/api/Profiles/IndividualBiddingProfileDelete",
        CompanyBiddingProfileDelete: "/api/Profiles/CompanyBiddingProfileDelete",
        deleteAllBiddingProfiles: "/api/Profiles/DeleteAllBiddingProfiles/:userId",
        retrieveRegistrationProcessStatus: "/api/Profiles/RetrieveRegistrationProcessStatus",
        finishRegistration: "/api/Profiles/FinishRegistration",
        updateProfileAddress: "/api/Profiles/UpdateAddress",
        setProfileAsDefault: "/api/Profiles/SetProfileAsDefault",
        adminCompanyBiddingProfileUpsert: "/api/Profiles/AdminCompanyBiddingProfileUpsert",
    },
    document: {
        createDocument: "/api/Document/CreateDocument",
        deleteDocument: "/api/Document/DeleteDocument",
        retrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecord: "/api/Document/RetrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecord",
        retrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecordByPublicAccess: "/api/Document/RetrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecordByPublicAccess",
        retrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecordByPrivateAccess: "/api/Document/RetrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecordByPrivateAccess",
        retrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecordByApprovedProfile: "/api/Document/RetrieveAllDocumentTemplatesAndDocumentsForRelatedTableRecordByApprovedProfile",
        retrieveTsAndCsForDocumentType: "/api/Document/RetrieveTsAndCsForDocumentType",
        retrieveRegistrationProcessDocuments: "/api/Document/RetrieveRegistrationProcessDocuments",
        retrieveRegistrationDocuments: "/api/Document/RetrieveRegistrationDocuments/:auctionId",
        uploadRegistrationProcessDocuments: "/api/Document/UploadRegistrationProcessDocuments",
        retrieveProfileDocuments: "/api/Document/retrieveProfileDocuments/:profileId/:profileType",
        downloadSecureFile: "/api/Document/DownloadSecureFile/",
    },
    notification: {
        getNotificationsByProfileId: "/api/Notification/RetrieveNotifications",
        getLotNotificationsByProfileId: "/api/Notification/RetrieveLotNotifications",
        setNotificationAsRead: "/api/Notification/SetNotificationAsRead",
        setAllNotificationsAsRead: "/api/Notification/SetAllNotificationsAsRead",
        deleteNotification: "/api/Notification/DeleteNotification",
        getNotificationCountByProfileId: "/api/Notification/RetrieveNotificationCount",
    },
    user: {
        retrieveAllRegisterdUsersByAuctionId: "/api/User/RetrieveAllRegisterdUsersByAuctionId",
        retrieveAllRegisterdUsersByAuctionIdWithPagination: "/api/User/RetrieveAllRegisterdUsersByAuctionIdWithPagination",
        update: "/api/User/RegisteredProfileUpdate",
    },
    lot: {
        addLot: "/api/Lot/CreateLot",
        getLots: "/api/Lot/RetrieveAll",
        retrieve: "/api/Lot/Retrieve",
        updateLot: "/api/Lot/UpdateLot",
        deleteLot: "/api/Lot/DeleteLot",
        linkLots: "/api/Lot/Link",
        unlinkLot: "/api/Lot/Unlink",
        updateLotRealtimeBiddingData: "/api/Lot/UpdateLotRealtimeBiddingData",
        retrieveLotsOverviewData: "/api/Lot/RetrieveLotsOverviewData",
        retrieveLotsOverviewDataWithPagination: "/api/Lot/RetrieveLotsOverviewDataWithPagination",
        retrieveLotBiddingHistory: "/api/Lot/RetrieveLotBiddingHistory",
        retrieveAuctionLotsForPostAuction: "/api/Lot/RetrieveAuctionLotsForPostAuction",
        retrieveLotPageData: "/api/Lot/RetrieveLotPageData",
        overrideWinningBidId: "/api/Lot/OverrideLotWinner",
        markLotAsSold: "/api/Lot/MarkLotAsSold",
        markLotAsUnsold: "/api/Lot/MarkLotAsUnsold",
        unlinkAllLotsFromAuction: "/api/Lot/UnlinkAllLotsFromAuction",
        retrieveWishlistProfilesByLotId: "/api/Lot/RetrieveWishlistProfilesByLotId",
        retrieveWishlistLotsByAuctionId: "/api/Lot/RetrieveWishlistLotsByAuctionId",
        retrieveAllRegisterdUsersByAuctionIdWithPagination: "/api/Lot/RetrieveAllRegisterdUsersByAuctionIdWithPagination",
        addLotType: "/api/Lot/CreateLotType",
        getLotTypes: "/api/Lot/RetrieveAllLotTypes",
        getLotTypesWithPagination: "/api/Lot/RetrieveAllLotTypesWithPagination",
        retrieveLotType: "/api/Lot/RetrieveLotType",
        updateLotType: "/api/Lot/UpdateLotType",
        deleteLotTypes: "/api/Lot/DeleteLotType",
        imagesRetrieveAllByLotId: "/api/LotImages/RetrieveAllByLot",
        imagesCreate: "/api/LotImages/Create",
        imagesUpdate: "/api/LotImages/Update",
        imagesDelete: "/api/LotImages/Delete",
        imagesRetrieve: "/api/LotImages/Retrieve",
        upsertLotVideo: "/api/LotVideos/UpsertLotVideo",
        deleteLotVideoById: "/api/LotVideos/DeleteLotVideoById/:lotVideoId",
        reorderLotsForAuction: "/api/Lot/ReorderLotsForAuction",
        extendLot: "/api/Lot/ExtendLot",
        updateReservePrice: "/api/Lot/UpdateReservePrice",
        updateStartPrice: "/api/Lot/UpdateStartPrice",
        lock: "/api/Lot/Lock",
        unlock: "/api/Lot/UnLock",
        generateBulkUploadTemplate: "/api/Lot/BulkUpload/Template",
        retrieveBulkUpload: "/api/Lot/BulkUpload/Retrieve/:id",
        retrieveAllBulkUploads: "/api/Lot/BulkUpload/Retrieve/All",
        retrieveAllBulkUploadImages: "/api/Lot/BulkUpload/Image/Retrieve/All",
        upsertBulkUpload: "/api/Lot/BulkUpload/Upsert",
        processBulkUpload: "/api/Lot/BulkUpload/Process/:id",
        deleteBulkUpload: "/api/Lot/BulkUpload/Delete/:id",
        addBulkUploadImage: "/api/Lot/BulkUpload/Image/Add",
        deleteBulkUploadImage: "/api/Lot/BulkUpload/Image/Delete/:id",
        retrieveFilteredLotPageData: "/api/Lot/RetrieveFilteredLotPageData",
        RetrieveFilteredMyActivityData: "/api/Lot/RetrieveFilteredMyActivityData",
        validateLotIsOpen: "/api/Lot/ValidateLotIsOpen/:auctionId/:lotId",
    },
    communication: {
        SignalRNegotiation: "/api/SignalR/SignalRNegotiation",
        createDebugLog: "/api/Logging/CreateDebugLog",
    },
};
